import styled, { keyframes } from 'styled-components' // eslint-disable-line no-unused-vars

const headerBgColor = `#FFFFFF`
const footerBgColor = `#FFFFFF`
const upcomingBg = `#E2E4E8`
const btColor = `#f60`
const localeActiveBorderColor = `#f60`
const entryFeeBntBg = `#f60`
const entryFeeBntColor = `white`
const eventCardRegisterBtnColor = `white`
const adjustBtnBG = `#f60`
const adjustBtnColor = `white`
const eventContentH1BgColor = `unset`
const eventContentDetailsBgColor = `white`
const eventContentBG = `white`
const sideBarBgColor = `white`
const profileBg = `white`
const profileColor = `black`
const registerNameColor = `white`
const historyListBg = `white`
const historyListColor = `black`
const inProfileBoxBg = `white`
const EditProfilePageContentBg = `white`
const profileInfoDataBoxColor = `white`
const eventBottomDetailTitleColor = `black`
const dashboardBg = `#E2E4E8`
// color 1st set
const simpleBgColor = `#ffa500`
const fontColor = `black`
// color 2nd set
const fontColor2 = `black`
const simpleBgColor2 = `#ffa500`

export const AppWrapper = styled.div`
  .EventRegisterPage {
    display: flex;
    justify-content: center;
    min-height: fill-available;
    .innerEventRegisterPage {
      width: 840px;
      
      .selectRegTypeContent {
        text-align: center;
        button.registrationTypeOption {
          min-width: 300px;
          max-width: 500px;
          display: block;
          margin: auto;
          margin-bottom: 12px;
        }
      }
    }
  }
  .eventContent table, .eventContent th, .eventContent td {
      border: 1px solid black;
  } 
  font-family: "Kanit", sans-serif;
  .modlink {
    color: beige;
    text-decoration: underline;
  }
  .modlink2 {
    color: #1890ff;
    text-decoration: underline;
  }
  .headerMenu .menuItem {
    display: inline-block;
    margin: 0 13px;
  }
  @media screen and (min-width:870px) {
    .menu_icon {
      display: none;
    }
    .headerMenu {
      display: inline-block;
      float: right;
      margin-right: 37px;
      font-size: 14px;
    }
  }
  .eventBottomDetail {
    margin-top: 15px;
    li {
      color: ${fontColor2};
    }
  }
  .modLoadding{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: auto;
    background: rgb(255,255,255,0.3);
    padding: 22px;
    border-radius: 20px;
  }
  .localeSwitcher .locale.active { 
    border-bottom: 2px solid ${localeActiveBorderColor}; 
  } 
  .registrationTopTitle {
    text-align: center;
    margin-bottom: 12px;
    font-size: 29px;
    color: black;
    font-weight: 600;
  }
  .registrationCode {
    color: ${fontColor2};
    font-size: 16px;
    margin-right: 8px;
  }
  .normal_btn.orangeborder_btn {
    border: 1px solid ${simpleBgColor2};
    color: ${simpleBgColor2};
    background-color: white;
    width: 100%;
  }
  .eventContent h1 {
    margin-bottom: 8px;
    margin-top: 26px;
    padding: 0 20px;
    display: inline-block;
    color: white;
    font-size: 20px;
    background: ${simpleBgColor2};
    text-align: center;
    width: 100%;
    text-align: left;
  }
  .short_description {
    min-height: 60px;
    padding-bottom: 10px;
    margin-bottom: 20px;
    background-color: ${simpleBgColor2};
  }
  .title_line > * {
    background-color: white;
    padding: 0 20px;
    margin-left: 40px;
    color: ${simpleBgColor2};
    display: inline-block;
  }
  .countdown_box .digi {
    border: 1px solid ${simpleBgColor2};
    display: inline-block;
    color: dimgray;
    background-color: #ffffff;
    width: 35px;
    line-height: 50px;
    font-size: 22px;
    margin: 2px;
  }
  .countdown_title {
    color: ${simpleBgColor2};
    margin-top: 10px;
  }
  .modSteps.ant-steps-horizontal.ant-steps-label-horizontal {
    padding: 0px 8px;
    @media screen and (max-width: 480px) {
      display: flex;
      flex-direction: row;
      .ant-steps-item {
        display: inline-block;
        .ant-steps-item-icon {
          margin-right: 0;
        }
        .ant-steps-item-content {
          display: none;
        }
      }
    }
  }
  .totalPrice {
    border-top: 1px solid;
    border-bottom: 3px black solid;
  } 
  .dashedBottom {
    border-bottom: 3px dashed rgba(0, 0, 0, 0.85);
    margin-top: 10px;
    padding-bottom: 5px;
  }
  
  .registrationPreviewDetailBox {
    display: inline-block;
    width: 100%;
    padding: 8px;
    border-bottom: 1px solid #a6a3a8;
    .code-box-title {
      font-family: kanit;
      color: black;
      font-size: 19px;
    }
    .runSubmittedBox {
      border: 2px solid gray;
      padding: 3px;
      border-radius: 8px;
      margin-bottom: 8px;
      margin-top: 8px;
      a, button {
        margin-bottom: 8px;
      }

      .ant-tag.status {
        margin-bottom: 8px;
      }
      img.run {
        margin-right: 3px;
        border: 2px solid gray;
        border-radius: 8px;
      }
    }
  }
  .eventBottomDetailBox {
    padding: 2px;
  }
  .eventBottomDetailTitle {
    color: ${eventBottomDetailTitleColor};
    font-size: 14px;
    padding-right: 15px;
    font-family: kanit;
  }
  .payButtom {
    text-align: center;
    background-color: ${simpleBgColor2};
    color: #ffffff;
    padding-top: 5px;
    padding-bottom: 5px;
    cursor: pointer;
  }
  .choosePayment:hover {
    border: 1px solid ${simpleBgColor2};
    cursor: pointer;
  }
  .lineLoginTitle {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
    height: 14px;
    font-size: 16px;
    border-bottom: 1px solid ${simpleBgColor2};
    text-align: center;
  }
  div.simpleBgColor {
    background: ${simpleBgColor};
    color: white;
  }
  div.ant-layout-header {
    height: 43px;
    transition: 0.5s all ease;
    width: 100%;
    padding: 0;
    border-bottom: 1px solid #dfe3e8;
    background-color: ${headerBgColor};
    position: sticky;
    z-index: 8;
    top: 0px;
  }
  div.ant-layout-content {
    background-color: ${upcomingBg};
    min-height: 100vh;
  }
  .adjustBtn {
    height: 30px;
    border-radius: 5px;
    background-color: ${adjustBtnBG} !important;
    color: ${adjustBtnColor} !important;
    min-width: 125px;
    text-align: center;
    display: inline-block;
    line-height: 30px;
    transition: 0.5s all ease;
    cursor: pointer;
  }
  
  .shape {
    min-width: 150px;
    padding: 0 20px;
    display: inline-block;
    height: 30px;
    -webkit-transform: skew(-20deg);
    -moz-transform: skew(-20deg);
    -o-transform: skew(-20deg);
    background: rgb(62, 111, 178);
    text-align: center;
  }
  .localeSwitcher .locale.active {
    border-color: ${localeActiveBorderColor};
  }
  a.login_btn {
    height: 30px;
    min-width: 125px;
    text-align: center;
    display: inline-block;
    transition: 0.5s all ease;
    cursor: pointer;
  }
  div.login_btn.login.menuItem {
    height: 30px;
    background-color: ${localeActiveBorderColor};
    color: ${fontColor};
    min-width: 125px;
    text-align: center;
    display: inline-block;
    line-height: 30px;
    transition: 0.5s all ease;
    cursor: pointer;
  }
  .menu_icon {
    margin-right: 17px;
    margin-top: 7px;
    cursor: pointer;
    color: ${btColor};
    position: absolute;
    right: 0;
    top: 0;
  }
  .loginButtonHeader {
    text-align: center;
    font-size: 14px;
    width: 100%;
    color: ${fontColor};
    background-color: ${btColor};
    padding: 5px;
  }

  .eventCardRegisterBtn {
    background: ${btColor};
    padding: 10px;
    border-radius: 15px;
    cursor: pointer;
    color: ${eventCardRegisterBtnColor};
    margin: 5px;
  }
  .closed {
    background: gray;
  }

  div.content.content-upcoming{
    text-align: center;
    max-width: 1250px;
    margin: auto;
    @media screen and (max-width: 795px ) {
      div.eventCard {
        height: auto !important;
      }
      div.eventName {
        white-space: normal !important;
      }
    }
    .eventCardImgWrapper {
      width: 360px;
      height: 200px;
      background: white;
    }
    div.eventCardBox {
      display: inline-block;
      margin: 15px;
      vertical-align: top;
      
      div.eventCard {
        border: 1px solid white;
        text-align: center;
        width: 360px;
        height: 320px;
        min-height: 320px;
        background: white;
        overflow: hidden;
        
        div.scheduleRaceBlock {
          div.innerScheduleRaceBlock {
            padding-left: 8px;
            padding-bottom: 8px;
            font-size: 16px;
            margin: auto;
            div.raceDateBox {
              display: inline-block;
              padding-left: 15px;
            }
            div.raceLocationBox {
              display: inline-block;
            }
            i {
              color: #ff6600;
              margin-right: 3px
            }
            i.vr {
              color: green;
            }
            i.location {
              color: red;
            }
          }
          div.dividerBlock {
            border-top: 1px solid rgb(255, 102, 0);
            width: 62%;
            margin: auto;
            padding: 2px;
          }
        }


        .eventRegStatusTags {
          position: absolute;
          .ant-tag {
            position: relative;
            bottom: 27px;
            margin-left: 8px;
          }
          .notOpenReg { 
            color: white;
            background: #ffb100;
            border-color: #ffb100;
          }
        }
        div.eventName {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 23px;
          color: black;
          text-align: left;
          padding: 5px;
          text-align: center;
        }
        .eventRegStatus {
          text-align: left;
          padding: 0 0 5px 5px;
        }
        
        .eventCardImg {
          width: 360px;
          height: 200px;
          object-position: center;
          object-fit: cover;
        }
      }:hover {
        box-shadow: 0 9px 9px rgba(0,0,0,0.19), 0 9px 9px rgba(0,0,0,0.19);
        touch-action: manipulation;
        cursor: pointer;
        div.eventCard {
          height: auto;
        }
        div.eventName {
          white-space: normal!important;
        }
      }
    }
    @media screen and (max-width : 375px) {
      div.eventCardBox {
        zoom: 86%;
        margin:15px 0;
      }
    }
    @media screen and (max-width : 720px) {
      div.eventCardBox {
        margin: 16px auto;
      }
    }
  }
  div.content.content-upcoming.finishedEvents {
    div.eventCardBox {
      margin: 8px;
      div.eventCard,
      div.eventCardImgWrapper,
      img.eventCardImg {
        height: 154px;
        width: 208px;
        min-height: unset;
        @media screen and (max-width : 720px) {
          width: 188px;
        }
        @media screen and (max-width : 375px) {
          height: 130px;
          width: 168px;
        }
      }
    }
  }

  .ant-layout-footer {
      background-color: ${footerBgColor};
  }
`
export const HeaderWrapper = styled.div`
  div.header {
    display: flex;
    justify-content: center;
    div.headerBg {
      margin-top: 7px;
      width: 990px;
      .logo {
        height: 30px;
        margin-left: 9px;
      }

      div.dropDown {
        margin-top: 6px;
        border-bottom: 1px solid #dfe3e8;
        div.menuList {
          transition: 1s all ease;
          text-align: center;
          font-size: 15px;
          color: #1890ff;
          background: white;
          position: relative;
          z-index: 1;
        }
        
        .menuItem {
          padding: 17px;
          display: block;
          width: 100%;
        }

        div.menuList:active {
          background: #1890ff;
        }
      }
    }
  }
`
export const EventPageContent = styled.div`
  display: flex;
  justify-content: center;
  .eventDateBox {
    background-color: white;
    border: 1px solid #dfe3e8;
    border-radius: 5px;
  }
  div.eventPage {
    color: #252525;
    width: 100%;
    max-width: 1200px;
    word-break: break-word;
    div.entryFeeBnt {
      height: 30px;
      background-color: ${entryFeeBntBg};
      color: ${entryFeeBntColor};
      border-radius: 3px;
      min-width: 125px;
      text-align: center;
      display: inline-block;
      line-height: 30px;
      cursor: pointer;
      font-family: 'Kanit';
      i {
        padding-left: 5px;
      }
    }
    .img-event {
      border: 1px solid #dfe3e8;
      img {
        width: 100%;
        height: auto;
      }
    }

    .dateBoxText {
      color: ${fontColor2};
      font-size: 26px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
    }
    table.entryFee {
      margin-top: 0;
      color: rgb(24,143,255);
      font-family: 'Kanit';
      thead {
        td {
          color: white;
        }
      }
      td {
        color: ${fontColor2};
        font-family: 'Kanit';
      }
      tr.entryFreeNameAndPrice {
        border-bottom: solid 3px #3c6dac8c;
      }
    }
    table {
      margin-bottom: 20px;
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
      background-color: transparent;
    }

    .eventContent {
      background-color: ${eventContentBG};
      border: 1px solid #dfe3e8;
      border-radius: 3px;
      font-size: 15px;
      font-weight: 400;
      padding: 15px;
      margin-top: 6px;
      img {
        width: calc(100% + 30px) !important;
        margin-left: -15px;
      }
      section h1 {
        background-color: ${eventContentH1BgColor};
        color: black;
        font-size: 17px;
        margin-top: 11px;
        font-weight: 600;
        padding: 0;
      }
      strong {
        font-weight: 600;
      }

      .details {
        padding: 15px;
        background: ${eventContentDetailsBgColor};
      }
    }

    /* @media screen and (max-width: 767px) {
      .eventContent {
        padding: 3px;
        margin: 8px 0 0 0;
      }
    } */


    .side_bar {
      padding: 10px 10px 20px 10px;
      background: ${sideBarBgColor};
      text-align: center;
      margin-left: 6px;
      margin-right: 6px;
      margin-top: 6px;
      border-radius: 3px;

      .no_pd {
        padding-left: 0px !important;
        padding-right: 0px !important;
        margin-right: 0px !important;
        margin-left: 0px !important;
        .fee_title_line {
          width: 100%;
          height: 14px;
          .title {
            font-size: 20px;
            color: ${fontColor2};
          }
        }
      }

      table thead {
        background-color: rgb(24,143,255);
        text-align: left;
      }
      table td {
        height: 30px;
        padding: 15px 8px 10px;
        min-height: 30px;
        text-align: left;
        font-size: 14px;
      }

      table td.fee {
        text-align: right;
        width: 88px;
      }

      table thead td {
        color: white;
        text-align: left;
      }

      .detailTitle {
        text-align: left;
        font-size: 20px;
        color: ${btColor};
        padding-left: 20px
      }
      .detailInfo {
        text-align: left;
        font-size: 16px;
        color: ${btColor};
        padding-left: 20px;
      }
    }
  }
`

export const ProfileBox = styled.div`
  display: flex;
  justify-content: center;
  .inProfileBox {
    width: 100%;
    background-color: ${inProfileBoxBg};
    padding: 20px;
    .profileIcon {
      padding: 0 20px;
      margin-bottom: 20px;
      padding-top: 25px;
    }
    .profileName {
      font-size: 18px;
      color: ${fontColor2};
    }
    .shapeTopic {
      min-width: 150px;
      padding: 0 20px;
      display: inline-block;
      height: 30px;
      background: rgb(71, 122, 187);
      text-align: center;
    }
    .profileInfo {
      margin-left: 20px;
      .profileNameBox {
        text-align: center;
        border-bottom: 1px solid gainsboro;
        padding-bottom: 25px;
        margin-bottom: 20px;
      }
      .profileInfoTitle {
        color: ${btColor};
        font-size: 16px;
        margin-left: 10px;
      }
      .profileInfoData {
        font-size: 20px;
        color: ${fontColor2};
      }
      .profileInfo {
        margin-left: 20px;
      }
      .profileInfoDataBox {
        margin-left: 20px;
      }
    }
  }
`

export const EditProfilePageContent = styled.div`
  padding-bottom: 16px;
  background-color: ${EditProfilePageContentBg};
  div.ant-form-item-label label {
    color: black;
  }
  div.profileInfo{
    .profileInfoTitle {
      color: ${btColor};
      font-size: 16px;
      margin-left: 10px;
    }
    
  }
  
  input {
    width: 269px;
  }
  .ant-form-item-control-wrapper {
    width: 269px;
  }
  
  .editProfileBox {
    display: flex;
    justify-content: center;
    margin: 20px;
    .editProfileButton {
      text-align: center;
      background-color: ${btColor};
      width: 60px;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 15px;
      padding-right: 15px;
      color: ${fontColor};
    }
    .editProfileButton:hover {
      cursor: pointer;
    }
  }
  .ant-form-item-label label {
    color: ${profileInfoDataBoxColor};
  }
`

export const DashBoardBox = styled.div`
  padding: 10px;
  display: flex;
  justify-content: center;
  background: ${dashboardBg};
  .contentWrapper {
    width: 909px;
    padding: 14px;
    .sortAndfilter {
      border-radius: 5px;
      .label {
        color: black;
        vertical-align: sub;
      }
      span.ant-input-group.ant-input-group-compact {
        display: inline-block;
        width: auto;
      }
      background-color: white;
      padding: 15px 0;
      color: black;
      text-align: center;
      margin-bottom: 12px;
    }
    .profile {
      background-color: ${profileBg};
      padding: 20px;
      margin-right: 20px;
      color: ${profileColor};
      border-radius: 5px;
      .eventTitle {
        font-size: 23px;
        display: block;
        text-align: center;
        color: black;
      }
      .registerName {
        color: ${profileColor};
      }
      .userRegister {
        i {
          background: rgb(24,143,255);
          padding: 10px;
          color: white;
          font-size: 83px;
          border-radius: 11px;
        }
      }
    }
    .registerName {
      margin: 15px 0;
      border-bottom: 1px solid gainsboro;
      width: 90%;
      padding-bottom: 20px;
      display: inline-block;
      font-size: 16px;
      color: ${registerNameColor};
    }
    .badgesBox {
      background-color: white;
      padding: 20px;
      margin: 20px;
      margin-left: 0;
      color: black;
      border-radius: 5px;
      img.badge {
        width: 51px;
      }
    }
    .historyList {
      padding: 12px;
      margin-bottom: 18px;
      background-color: ${historyListBg};
      color: ${historyListColor};
      border-radius: 5px;
      .sendingItem {
        font-weight: normal;
        font-family: initial;
        font-style: italic;
        color: darkorange;
      }
      .eventTitle {
        font-size: 21px;
        display: block;
        border-bottom: 1px solid gray;
        a {
          color: black;
        }
        a:hover {
          color: blue;
          text-decoration-color: blue;
        }
      }
      .registrationCode {
        color: black;
      }
      .eventBottomDetail {
        margin: 0;
        li {
          color: black;
        }
        .eventBottomDetailTitle {
          color: black;
          font-size: 14px;
          padding-right: 15px;
          margin-top: 7px;
        }
      }
    }
    @media screen and (max-width: 767px) {
      .profile {
        margin-right: 0;
      }
      .badgesBox {
        margin-right: 0;
      }
    }
  }
`

export const Registration = styled.div`
  .canSubmitRunBtn {
    margin-top: 6px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    margin-bottom: 3px;
    display: block;
    height: auto;
  }
`

export const FooterWrapper = styled.div`
`

export const PricingWrapper = styled.div`
  img.pricing {
    width: 100%;
  }
`
export const EventFormWrapper = styled.div` 
  input, .ant-select-selection.ant-select-selection--single , textarea {
    max-width: 388px;
  }
}

`
export const EventFormSuccessWrapper = styled.div` 
`



// WEBPACK FOOTER //
// ./src/styles/index.js